import React,{useState,useEffect,useCallback} from 'react';
import DataTable from 'react-data-table-component-footer';
import * as RestService from '../../services/eisRest';
import { Button} from 'react-bootstrap';

import FileSaver from 'file-saver';
import LoadingOverlay from 'react-loading-overlay';
import {useTranslation} from 'react-i18next';
import * as moment from 'moment';
import 'moment/locale/sk';

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

const DataTableAttendanceEvent = (props) => {

    const [t] = useTranslation();      
    const [url, setUrl] = useState();
    const [page] = useState(1);
    const [size] = useState(1000);
    const [search] = useState('');
    const [data, setData] = useState();
  //  const [columns, setColumns] = useState(props.columns);
  //  const [columnsData, setColumnsData] = useState(props.columnsData);
    const [loading, setLoading] = useState(false);
    const [exportRunning, setExportRunning] = useState(false);    
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(40);
    const [currentPage, setCurrentPage] = useState(1);    
    const [selectedColumn, setSelectedColumn] = useState(1);    
    const [sortDirection, setSortDirection] = useState('asc');        
    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);        
  //  const [modalShow, setModalShow] = useState(props.modalShow);
  //  const [checkTime, setCheckTime] = useState(null);
   

    const customStyles = {
      rows: {
        style: {
        //  fontFamily: "Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif",
          fontSize: '15px'
        }        
      },
      header: {
        style: {
          fontSize: '22px',
          fontWeight: 800
        },
      },     
      headCells: {
        style: {
          fontSize: '17px',
          fontWeight: 800
          
        },
      }
    };


   const handleOnSort = (selectedColumn, sortDirection ) => {
      setSelectedColumn(selectedColumn);
      setSortDirection(sortDirection);
      
      props.columnsData.find(function(item, i){
        
        if(item.data === selectedColumn.data){
          setSelectedColumn(i);
          fetchData(url,currentPage,perPage,i,sortDirection);
        }
      });

      
   }

    
    const fetchData = useCallback(async () => { //url,page, size = perPage, selectedColumn = 1, sortDirection = 'asc', search = ''
        if(typeof url=== 'undefined'){return;}
        setLoading(true);          
             
        RestService.callAnyApi(url,{
            columns: props.columnsData,
            order: [{column: selectedColumn,dir: 'asc'}],
            search: {value: search,regex: false},
            draw: page-1,
            length: size,
            start: ((page-1)*size)          
        })
          .then((response) => {          
                  

            setData(response.data);
            setTotalRows(response.recordsFiltered);
            setLoading(false);
          })
          .catch((error) => {               
            setLoading(false);
          });
    
       
      }, [url,selectedColumn,search,page,size]);

      
     
   //   const callFetchData  = useCallback(() => {    
     //   fetchData(url,currentPage,perPage,selectedColumn,sortDirection,filterText);
    //  }, [fetchData,url,currentPage,perPage,selectedColumn,sortDirection,filterText]);
    
  
      useEffect(() => {
        if(typeof url=== 'undefined'){return;}
        fetchData();
      }, [fetchData,props.checkTime]);
    

      useEffect(() => {
        if(typeof url=== 'undefined'){return;}
        if(!props.modalShow){
          fetchData();        
        }
      }, [fetchData,props.modalShow]);
    

      useEffect(() => {                  
          setUrl(props.url);
          if(typeof props.url=== 'undefined'){return;}  
          fetchData();
          //fetchData(props.url,currentPage,perPage,selectedColumn,sortDirection,filterText);
      }, [fetchData,props.url]);
    
    
      

      const handlePageChange = page => {
        fetchData(page);
        setCurrentPage(page);
        fetchData(url,page, perPage);
      };
    
      const handlePerRowsChange = async (newPerPage, page) => {
        fetchData(url,page, newPerPage);
        setPerPage(newPerPage);
      };

  
      const handleRowClicked = (row) =>{
        //console.log(row);
        props.parentCallback(row.id); 
      }


      const exportExcel = () =>{
          setExportRunning(true);       
          RestService.downloadExceFile(props.urlExcel,{
                columns: props.columnsData,
                order: [{column: selectedColumn,dir: sortDirection}],
                search: {value: filterText,regex: false},
                draw: currentPage-1,
                length: perPage,
                start: ((currentPage-1)*perPage)          
          })
          .then((response) => {       
             //FileDownload(response.data, 'report.xls');   
             FileSaver.saveAs(response.data, 'report.xls');
             setExportRunning(false);       
             // console.log(response);
          })
          .catch((error) => {               
            console.log(error);
            setExportRunning(false);       
          });               

      };

      const conditionalRowStyles = [
        {
          when: row => row.weekend ,
          style: {
            color: "red",
            userSelect: "none"
          }
        }
      ];




      const getHours = (value) => {
        if(value==null){
            return '';
        }else{
            return moment.duration(value,'milliseconds').format('HH:mm',{trim: false });
        }
        return '';
    }

      const sumTotal = () => {
        let x = 0;
        if(data){
        data.map((item) => {         
              x += item.interval;         
        });
      }      
        return getHours(x);
      };

      const footerObject =  {
        
       
        intervalText: sumTotal(),
       

        
      };

     

  

        return (
          <>
         <LoadingOverlay
  active={exportRunning}
  spinner
  text='Export running...'
  >
  <DataTable
             //   subHeader
              //  subHeaderComponent={subHeaderSumary}
              //  subHeader={false}
            //   fixedHeader
            //    footerBold={true}
              //  footer={footerObject}
            
                columns={props.columns}
                data={data}                
                progressPending={loading}
                //pagination
                //paginationServer
                //sortServer         
              //  paginationTotalRows={totalRows}
              //  paginationDefaultPage={currentPage}
              //  onChangeRowsPerPage={handlePerRowsChange}
              //  onChangePage={handlePageChange}
            //    onSort={handleOnSort}              
               // selectableRows
                highlightOnHover
                onRowClicked={handleRowClicked}                
                onSelectedRowsChange={({ selectedRows }) => console.log(selectedRows)}
                paginationResetDefaultPage={resetPaginationToggle} 
                customStyles={customStyles}
                dense             
                conditionalRowStyles={conditionalRowStyles}
                footer={footerObject}
                />
</LoadingOverlay>
                
                  
          </>

          
        );
}

export default DataTableAttendanceEvent;